import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import discordIntegrationService from '../../../services/discordIntegrationService';

const DiscordCallbackPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const state = searchParams.get('state');
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const finalize = async () => {
      if (!code || !state) { setError('Missing code or state'); return; }
      const expected = sessionStorage.getItem('discord_oauth_state');
      if (expected && expected.split(':')[0] !== state.split(':')[0]) {
        // Only compare user id portion for resilience across nonce regeneration
        setError('State mismatch. Please retry the connection.'); return;
      }
      try {
        const resp = await discordIntegrationService.finalizeCallback(code, state);
        if (resp.success) {
          navigate('/creator/integrations/discord/manage');
        } else {
          setError('Discord authorization failed');
        }
      } catch (e: any) {
        setError(e?.response?.data?.error || e?.message || 'Callback failed');
      }
    };
    finalize();
  }, [code, state, navigate]);

  return (
    <div className="p-6 max-w-xl">
      <h1 className="text-xl font-semibold mb-4">Finalizing Discord Connection</h1>
      {!error && <p className="text-gray-600">Please wait while we complete the authorization…</p>}
      {error && <div className="text-red-600">{error}</div>}
    </div>
  );
};

export default DiscordCallbackPage;